import { type FC, useMemo } from 'react'
import { useRange, type UseRefinementListProps } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import { productSearchGetRefinementLabel } from '../productSearchGetRefinementLabel'
import {
  ProductSearchRefinement,
  ProductSearchRefinementContext,
} from '../ProductSearchRefinement'
import { productSearchRefinementRangeRenderValue } from '../ProductSearchRefinementRange'
import { useProductSearchRefinementStateContext } from '../ProductSearchRefinementStateContext'

import { ProductSearchRefinementPriceListbox } from './ProductSearchRefinementPriceListbox'

type ProductSearchRefinementPriceRangeProps = Pick<
  UseRefinementListProps,
  'attribute'
> & {
  hidden: boolean
}

export const ProductSearchRefinementPriceRange: FC<
  ProductSearchRefinementPriceRangeProps
> = ({ attribute, hidden }) => {
  const intl = useIntl()

  const {
    state: { isMobile },
  } = useProductSearchRefinementStateContext()

  const refinementRange = useRange({ attribute })

  const { canRefine, start } = refinementRange

  const contextValue = useMemo(
    () => ({
      refinementRange,
      refinementRangeOptions: {
        attribute,
      },
    }),
    [attribute, refinementRange],
  )

  if (hidden || !canRefine) {
    return null
  }

  const formLabel = productSearchGetRefinementLabel(attribute, intl)

  return (
    <div>
      <ProductSearchRefinementContext value={contextValue}>
        <ProductSearchRefinement
          attribute={attribute}
          data-qa-id={`form-${formLabel}`}
          listboxOpen={isMobile ? true : undefined}
          renderValue={() =>
            productSearchRefinementRangeRenderValue(formLabel, start)
          }
          slotProps={{
            popup: {
              /**
               * Price is always visible on mobile, according to Figma design https://www.figma.com/design/SAgPieIZTeJfx40kjmRwYZ/WSAWA-5583--SERP---HomeOne-migration?node-id=914-13448&m=dev
               */
              keepMounted: isMobile,
            },
          }}
          slots={{
            listbox: ProductSearchRefinementPriceListbox,
          }}
        />
      </ProductSearchRefinementContext>
    </div>
  )
}
